const config = {
  opt_notice_uploaded: { ALL: "ALL", TRUE: "UPLOADED", FALSE: "NOT UPLOADED" },
  opt_progressive: ["NONE", "PENDING", "QRIS_CREATED", "PAID"],
  list_menu: [
    { id: 1, link: "/dashboard" },
    { id: 3, link: "/monitoring/order" },
    { id: 4, link: "/monitoring/progresif" },
    { id: 5, link: "/monitoring/dokumen" },
    { id: 6, link: "/monitoring/samsat" },
    { id: 9, link: "/dokumen/notice/upload" },
    { id: 26, link: "/dokumen/notice/upload/v2" },
    { id: 10, link: "/dokumen/notice/multi-upload" },
    { id: 11, link: "/dokumen/notice/multi-upload/log" },
    { id: 12, link: "/dokumen/stnk/upload" },
    { id: 13, link: "/dokumen/bpkb/upload" },
    { id: 14, link: "/dokumen/update/nomor-dokumen" },
    { id: 16, link: "/upload-tagihan/notice" },
    { id: 17, link: "/upload-tagihan/jasa" },
    { id: 18, link: "/pembayaran/tagihan/notice" },
    { id: 19, link: "/pembayaran/tagihan/process" },
    { id: 20, link: "/pembayaran/tagihan/pkb" },
    { id: 21, link: "/update/status-tagihan" },
    { id: 24, link: "/internal/pembayaran-ulang/tagihan/notice" },
    { id: 24, link: "/internal/pembayaran-ulang/tagihan/notice-new" },
    { id: 25, link: "/internal/pembayaran-ulang/tagihan/proses" },
  ],

  status_bbn: {
    INPUTED: "INPUTED",
    UPLOADED: "UPLOADED",
    GENERATED: "GENERATED",
    FINISHED: "FINISHED",
    CANCELED: "CANCELED",
  },
  status_bayar: {
    ALL: "ALL",
    LUNAS_NOTICE: "LUNAS NOTICE",
    LUNAS_PROSES: "LUNAS PROSES",
    BELUM_LUNAS_NOTICE: "BELUM LUNAS NOTICE",
    BELUM_LUNAS_PROSES: "BELUM LUNAS PROSES",
  },
  status_notice: {
    TRUE: "UPLOADED",
    FALSE: "NOT UPLOADED",
  },
  status_bayar_notice: {
    GENERATED: "LUNAS NOTICE & PROCESS",
    UPLOADED: "BELUM LUNAS NOTICE & PROCESS",
  },
  type_bill: {
    BILL_PROSES: "Tagihan Proses",
    BILL_PKB: "Tagihan PKB",
    BILL_JASA: "Tagihan Jasa",
  },
  porta_biro_jasa_apikey: "hwfub9Mvj29SLFL9hrOIH7EedeUjnX4U1kckJiQW",
  limit_pay_invoice: 200000000,
  limit_pay_process: 25000000,
  allowed_menu_repay: ["rora biro"],
  version: "0.4.9",
  maintenance: false,
  option_target_bill: ["default", "customize"],
  exceptionBBN: ["AIMND", "AWMND", "AJGTO", "WJYGTO"],
  option_notice_type: ["JABAR 2025", "MANADO 2025", "GORONTALO 2025", "JABAR 2024", "GORONTALO 2024", "JAKARTA", "MANADO", "TANGERANG"],
  // option_notice_type: ["JABAR", "JAKARTA", "MANADO", "GORONTALO"],
};

export { config };
